import { render, staticRenderFns } from "./leftNavTeacher.vue?vue&type=template&id=370e65fc&scoped=true&"
import script from "./leftNavTeacher.vue?vue&type=script&lang=js&"
export * from "./leftNavTeacher.vue?vue&type=script&lang=js&"
import style0 from "./leftNavTeacher.vue?vue&type=style&index=0&id=370e65fc&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "370e65fc",
  null
  
)

export default component.exports